
import React, { useEffect, useRef } from "react";

const Mission = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const elements = entry.target.querySelectorAll(".fade-in-element");
            elements.forEach((el, index) => {
              setTimeout(() => {
                el.classList.add("animate-fade-in");
              }, index * 100);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="mission" style={{ backgroundColor: '#F2F3EE' }} className="w-full m-0 p-0" ref={sectionRef}>
      <div className="container px-4 sm:px-6 lg:px-8 mx-auto" style={{ backgroundColor: '#F2F3EE' }}>
        {/* Header with badge and line */}
        <div className="flex items-center gap-4 mb-8 sm:mb-16 justify-center md:justify-start">
          <div className="flex items-center gap-4">
            <div className="inline-flex items-center justify-center px-4 py-2 rounded-full opacity-0 fade-in-element" style={{
              backgroundColor: 'rgba(242, 76, 39, 0.1)',
              border: '1px solid rgba(242, 76, 39, 0.2)',
              color: 'rgba(242, 76, 39, 1)'
            }}>
              <span style={{
                backgroundColor: 'rgba(242, 76, 39, 1)'
              }} className="inline-flex items-center justify-center w-5 h-5 rounded-full text-white mr-2 text-sm">6</span>
              <span>Our Mission</span>
            </div>
          </div>
          <div style={{
            backgroundColor: 'rgba(242, 76, 39, 0.2)'
          }} className="hidden md:block flex-1 h-[1px] opacity-0 fade-in-element"></div>
        </div>
        
        {/* Main content with mission statement */}
        <div className="max-w-5xl mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-display leading-tight mb-8 sm:mb-12 pb-2 opacity-0 fade-in-element text-left mx-[15px] sm:mx-0" style={{
            background: 'linear-gradient(135deg, rgba(242, 76, 39, 1) 0%, rgba(31, 31, 30, 1) 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            color: 'transparent'
          }}>
            We target the best. Since 2008, we've organized world-class tech events, accelerated hundreds of startups, and helped them raise millions in funding. Now we're focusing on the future: AI innovation.
          </h2>
        </div>
      </div>
    </section>
  );
};

export default Mission;
